module.exports = __webpack_public_path__ + "static/img/heart_256.ae58170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart_256.png
// module id = eUhA
// module chunks = 4